import React from 'react';
import ImageZoom from 'react-image-zooom';

import pictoClose from "../assets/images/close.svg";
import {urlDirectus} from "../Map/config/globals";

export const PlanDeCoupe = ({closePlanDeCoupe, batimentCourant, resetAndShowOneLayer, setMatiereCouranteandShow, setAndShowImage, affichePlanDeCoupeMaquette}) => {
    return (
        batimentCourant.infos &&
        <div id="plan-coupe-interactif" className="plan-coupe-interactif off h-100 bg-architecture position-absolute bottom-0 p-4 d-flex">
            <div className="col-12 flex-grow-1 bg-white rounded-4 h-100 p-3 p-xl-4 d-flex flex-column">
                <div className="d-flex flex-column pb-3 mb-4 border-bottom border-architecture border-2">
                    <div className="d-flex align-items-center justify-content-start position-relative">
                        <div
                            className="mini-popup-carte-picto bg-architecture rounded-3 ratio-11 d-flex align-items-center justify-content-center position-absolute start-0 overflow-hidden">
                        </div>
                        <div className="dotted-pattern dotted-pattern-purple dotted-pattern-simple"></div>
                        <div className="d-flex flex-column justify-content-center text-start lh-sm px-3">
                            <span className="fw-b fs-5">
                                {(() => {
                                    if(affichePlanDeCoupeMaquette == 1){
                                        return "Maquette de détail";
                                    }else{
                                        return "Plan de coupe interactif";
                                    }
                                })()}
                                </span>
                            <span className="text-spectral text-muted">{batimentCourant.nom}</span>
                        </div>
                        <button className="toggle-btn ms-auto" onClick={closePlanDeCoupe}>
                            <img src={pictoClose} />
                        </button>
                    </div>
                </div>
                <div className="col-plan col-12 flex-grow-1 d-flex flex-wrap">
                    <div className="col-8 col-xxl-9 h-100 text-center bg-white border rounded-2 position-sticky top-0">
                        {(() => {
                            if(affichePlanDeCoupeMaquette == 1){
                               return batimentCourant.infos.plandecoupe && <ImageZoom className="img-plan h-100 img-fluid object-fit-contain" src={urlDirectus + 'assets/'+ batimentCourant.infos.maquette.id} alt="Plan de coupe"/>

                            }else{
                                return batimentCourant.infos.maquette && <ImageZoom className="img-plan h-100 img-fluid object-fit-contain" src={urlDirectus + 'assets/'+ batimentCourant.infos.plandecoupe.id} alt="Maquette de détail"/>
                            }
                        })()}
                    </div>
                    <div className="col-4 col-xxl-3 ps-4 d-flex flex-column">
                        <div className="d-flex flex-column align-items-start pb-3 mb-3 min border-bottom border-2">
                            <span className="fw-b fs-4 text-architecture lh-xs">Matières</span>
                            <span className="fw-b fs-4 text-black lh-xs">Chaînes opératoires</span>
                        </div>
                        {(() => {
                            if (batimentCourant.infos && batimentCourant.infos.matiere_chaine.length > 0) {
                                return (
                                    <>
                                        {
                                            batimentCourant.infos.matiere_chaine.map((matiere_chaine, index) => {

                                                return (
                                                <div className="d-flex flex-column w-100 align-items-start justify-content-center position-relative bg-light-architecture rounded-2 p-3 pb-2 mb-3">
                                                    <div className="d-flex w-100 justify-content-between flex-wrap border-bottom border-2">
                                                        <span className="fw-b fs-5 text-architecture pe-2 min-w-label">{matiere_chaine.groupe_matiere_chaine_id.ref_matiere}</span>
                                                        <div className="d-flex flex-column align-items-stretch">
                                                            <a onClick={()=>resetAndShowOneLayer(matiere_chaine.groupe_matiere_chaine_id.matiere[0].item.stylecss)} className="btn btn-mini btn-architecture-transp px-1 mb-2 min-w-button">Carte</a>
                                                            <a onClick={()=>setMatiereCouranteandShow(matiere_chaine.groupe_matiere_chaine_id.matiere[0].item)} className="btn btn-mini btn-architecture-transp px-1 mb-2 min-w-button">Fiche</a>
                                                        </div>
                                                    </div>

                                                    <div className="d-flex w-100 justify-content-between pt-2 flex-wrap">
                                                        <span className="fw-b fs-5 text-black pe-2 min-w-label">{matiere_chaine.groupe_matiere_chaine_id.ref_chaine}</span>

                                                        <div className="d-flex flex-column align-items-stretch">
                                                            {
                                                                matiere_chaine.groupe_matiere_chaine_id.chaine[0].item.image_matiere[0].item.image &&
                                                                <a onClick={()=> setAndShowImage('scroll',urlDirectus+'assets/'+matiere_chaine.groupe_matiere_chaine_id.chaine[0].item.image_matiere[0].item.image,matiere_chaine.groupe_matiere_chaine_id.chaine[0].item.image_matiere[0].item.libelle,matiere_chaine.groupe_matiere_chaine_id.chaine[0].item.image_materiau[0].item.source) } className="btn btn-mini btn-transp-black btn-transp-black-border-1 px-1 mb-2 min-w-button">Matière</a>
                                                            }
                                                            {
                                                                matiere_chaine.groupe_matiere_chaine_id.chaine[0].item.image_materiau[0].item.image &&
                                                                <a onClick={()=> setAndShowImage('scroll',urlDirectus+'assets/'+matiere_chaine.groupe_matiere_chaine_id.chaine[0].item.image_materiau[0].item.image,matiere_chaine.groupe_matiere_chaine_id.chaine[0].item.image_materiau[0].item.libelle,matiere_chaine.groupe_matiere_chaine_id.chaine[0].item.image_materiau[0].item.source) }  className="btn btn-mini btn-transp-black btn-transp-black-border-1 px-1 mb-2 min-w-button">Matériau</a>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                );

                                            })
                                        }
                                    </>
                                )
                            }else{
                                return "AUCUN";
                            }
                        })()}

                        <div className="dotted-pattern opacity-25 dotted-pattern-simple w-100 mt-auto"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}


